<template>
  <div class="container" style="height: 100%">
    <div class="top">
      <div class="back_box">
        <!-- <img src="@/assets/images/icons/icon_back.png" alt="" /> -->
        <el-button
          class="back-btn"
          type="text"
          icon="el-icon-arrow-left"
          @click="$router.go(-1)"
          >返回</el-button
        >
      </div>
      <div class="info">
        <p class="title">{{ info.name }}</p>
        <p style="margin-top: 5px">
          <span class="time">{{
            formatDate(info.startTime, "MM-DD HH:mm")
          }}</span>
          <span class="shu">|</span>
          <span class="surplus" v-show="info.autoStop && info.status != 'STOP'"
            >剩余<i class="el-icon-time"></i>{{ surplus }}</span
          >
          <span class="end" v-show="info.status == 'STOP'">已结束</span>
        </p>
        <div class="right_btns">
          <!-- <el-button type="text">导出数据</el-button> -->
          <el-button
            type="text"
            v-show="info.status != 'STOP'"
            @click="handleStop"
            >结束活动</el-button
          >
        </div>
      </div>
    </div>
    <div class="main">
      <template v-if="list.length > 0">
        <p class="main_title">抢答排名</p>
        <div class="list_box">
          <div class="one" v-for="(item, idx) in list" :key="item.userId">
            <div class="idx">
              <img
                v-if="idx == 0"
                src="@/assets/images/icons/icon_first.png"
                alt=""
              />
              <span v-else>{{ idx + 1 }}</span>
            </div>
            <el-image class="avatar" :src="item.avatar" fit="cover"></el-image>
            <div class="right">
              <p class="name">{{ item.nickName }}</p>
              <p class="time">{{ item.duration }}秒</p>
            </div>
          </div>
        </div>
      </template>
      <div class="empty" v-else>
        <p>暂无人抢答</p>
      </div>
    </div>
  </div>
</template>

<script>
import mixinsData from "../mixins/detail";
import { answerList } from "@/api/activity/answer";
import { formatDate } from "@/utils/index";
export default {
  name: "answer",
  mixins: [mixinsData],
  data() {
    return {
      formatDate,
      info: {},
      surplus: "",
      list: [],
    };
  },
  methods: {
    // 抢答学生列表
    getList() {
      let activityId = this.$route.query.activityId;
      answerList({ activityId }).then((res) => {
        if (res.code == 0) {
          this.list = res.data;
        } else {
          console.log(res.msg);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.top {
  margin-top: 30px;
  margin-bottom: 20px;
  width: 100%;
  text-align: left;
  .back_box {
    display: inline-block;
    width: calc(100% - 1126px);
    text-align: center;
    vertical-align: middle;
    cursor: pointer;
    img {
      width: 44px;
    }
    p {
      color: #969696;
      font-size: 16px;
    }
  }
  .info {
    position: relative;
    display: inline-block;
    padding: 24px 30px;
    background-color: #fff;
    width: 1126px;
    vertical-align: middle;
    .title {
      font-size: 16px;
      color: #333;
    }
    .time {
      margin-top: 5px;
      color: #999;
      font-size: 14px;
    }

    .shu {
      padding: 0 10px;
      color: #ddd;
    }
    .el-icon-time {
      margin: 0 5px;
    }
    .surplus {
      color: sandybrown;
    }
    .end {
      color: #999;
    }
    .right_btns {
      position: absolute;
      top: 50%;
      right: 30px;
      transform: translateY(-50%);
    }
  }
}

.main {
  height: calc(100% - 30px - 20px - 93px - 30px);
  .main_title {
    padding-left: 80px;
    margin-bottom: 20px;
    font-size: 16px;
    text-align: left;
  }
  .list_box {
    height: calc(100% - 41px);
    padding-bottom: 30px;
    background-color: #fff;
    text-align: left;
    overflow-y: auto;
    &::-webkit-scrollbar {
      width: 4px;
      background-color: #f5f5f5;
    }

    &::-webkit-scrollbar-track {
      box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
      -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
      border-radius: 10px;
      background-color: #f5f5f5;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 10px;
      box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
      -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
      background-color: #c8c8c8;
    }

    .one {
      display: inline-block;
      width: 399px;
      border-right: 1px solid #ebebeb;
      padding: 20px;
      border-bottom: 1px solid #ebebeb;
      .idx,
      .avatar,
      .right {
        display: inline-block;
        vertical-align: middle;
        &.idx {
          color: #999;
        }
        &.avatar {
          margin: 0 20px;
          width: 40px;
          height: 40px;
        }
        &.right {
          .name {
            font-size: 16px;
            color: #282828;
          }
          .time {
            font-size: 14px;
            color: #999;
          }
        }
      }
    }
  }
  .empty {
    position: relative;
    height: 100%;
    background-color: #fff;
    p {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-size: 28px;
      color: #c8c8c8;
    }
  }
}
</style>